import { withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';

const styles = (theme) => ({
  root: {
    padding: 0,
    verticalAlign: 'middle',
    height: '100%',
    width: 30,
    alignSelf: 'center',
    color: theme.gridIconBorderColor,
    '&$checked': {
      color: theme.HeaderSelectedText
    }
  },
  checked: {
    color: theme.HeaderSelectedText
  }
});

const RadioRenderer = (props) => {
  const { classes, value, colDef, disabled, node } = props;
  const field = colDef?.field;
  const handleChange = (_event, isChecked) => {
    if (field) {
      node.setDataValue(field, isChecked);
    }
  };

  return (
    <Radio
      checked={value}
      onChange={handleChange}
      value="a"
      name="isActive"
      aria-label="A"
      color="primary"
      disabled={disabled}
      classes={{
        root: classes.root,
        checked: classes.checked
      }}
    />
  );
};

export default withStyles(styles)(RadioRenderer);
